export const ADMIN_SHELF_LIST_TAB = {
  field: 'active',
  multiSelect: false,
  tabs: [
    { key: 'Active', label: 'Active', value: 'true' },
    { key: 'Inactive', label: 'Inactive', value: 'false' },
  ],
};
